<template>
  <!-- 使用明細 -->
  <div id="CpapUsedList">
    <div id="container-left">
      <div class="labelTitle lable unPrintTarget">使用明細</div>
      <!--検索条件 -->
      <div class="condition-area printTarget">
        <table class="conditionTable unPrintTarget">
          <tr>
            <!-- 前々月、前月、当月のみ検索可能-->
            <th>年月</th>
            <td style="width:200px;"><input v-model="yearMonth" type="month" @change="changeYearMonth" :min="yearMonthMin" :max="yearMonthMax"/></td>
            <template v-if="isInnerUser">
              <th>組織選択</th>
              <td style="width:400px;">
                <input class="hospitalInput" type="text" style="width:270px;" disabled="disabled" v-model="medicalInstitutionName"/>
                <b-button style="margin-left:10px; width:120px; height:27px;" @click="organizationModalActive=true">組織選択</b-button>
              </td>
            </template>
          </tr>
        </table>
        <div class="searchButton-area unPrintTarget">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <div v-if="data.details.length > 0" class="result-area unPrintTarget">
        <template>
          <table  class="conditionTable" style="margin-top:15px;margin-bottom:15px;">
            <tr>
              <th style="width:10%;">状態</th>
              <td style="width:20%;text-align:center;font-weight:bold;">
                <template v-if="isExtUser">
                  <template v-if="!data.ApprovalFlag">得意先確認待ち</template>
                  <template v-else>回答返信済</template>
                </template>
                <template v-else-if="isInnerUser">
                  <!--１ 対象の医療機関のデータのステータスが、確認中の場合-->
                  <template  v-if="!data.ConfirmFlag && !data.ApprovalFlag">内容確認中</template>
                  <!--２ 対象の医療機関のデータのステータスが、承認依頼中の場合-->
                  <template v-else-if="data.ConfirmFlag && !data.ApprovalFlag">顧客承認待ち</template>
                  <!--３ 対象の医療機関のデータのステータスが、デビクレ中の場合-->
                  <template v-else-if="!data.DebitCreditFlag">返信内容確認中</template>
                  <!--３ 対象の医療機関のデータのステータスが、デビクレ済みの場合-->
                  <template v-else>確認完了</template>
                </template>
              </td>
              <td style="width:70%;">
                <template v-if="isExtUser">
                  <!-- ログインユーザーが社外ユーザーの場合　修正可能（締め日（翌月6日）以前）状態では、以下のメッセージを表示-->
                  <template v-if="!data.ApprovalFlag">使用明細を確認の上、確定しましたら担当者へ返送してください。</template>
                  <template v-else>Philipsへ回答を返信しました。<br>一時保存を押した場合は、Philipsへ送信した使用明細内容も変更されますので、ご注意ください。<br>（Philipsへ変更の通知はされませんので別途ご連絡ください。）</template>
                </template>
                <template v-else-if="isInnerUser">
                  <!-- ログインユーザーが社内ユーザーの場合　修正可能（締め日（翌月6日）以前）状態では、以下の１か２,３どちらかのメッセージを表示-->
                  <!--１ 対象の医療機関のデータのステータスが、確認中の場合-->
                  <template  v-if="!data.ConfirmFlag && !data.ApprovalFlag">使用明細を編集して『顧客に送信』ボタンを押してください。</template>
                  <!--２ 対象の医療機関のデータのステータスが、承認依頼中の場合-->
                  <template v-else-if="data.ConfirmFlag && !data.ApprovalFlag">使用明細は顧客に承認を依頼中です。<br>一時保存を押した場合は、顧客へ送信した使用明細内容も変更されますので、ご注意ください。<br>（顧客へ変更の通知はされません。）</template>
                  <!--３ 対象の医療機関のデータのステータスが、デビクレ中の場合-->
                  <template v-else-if="!data.DebitCreditFlag">得意先記入欄を確認の上、必要に応じてデビクレ処理を行ってください。<br>一時保存を押した場合は、顧客へ送信した使用明細内容も変更されますので、ご注意ください。<br>（顧客へ変更の通知はされません。）</template>
                  <!--３ 対象の医療機関のデータのステータスが、デビクレ済みの場合-->
                  <template v-else>使用明細の確認を完了しました。<br>一時保存を押した場合は、顧客へ送信した使用明細内容も変更されますので、ご注意ください。<br>（顧客へ変更の通知はされません。）</template>
                </template>
              </td>
            </tr>
            <tr>
              <td colspan="3">
              <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
                <b-step-item step="1" label="Philips確認中" icon="comment-alert-outline"></b-step-item>
                <b-step-item step="2" label="得意先確認中" icon="hospital-building"></b-step-item>
                <b-step-item step="3" label="Philips内容確認中" icon="clipboard-edit-outline"></b-step-item>
                <b-step-item step="4" label="確認完了" icon="cloud-upload"></b-step-item>
              </b-steps>
              </td>
            </tr>
          </table>
        </template>
        <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow()">行追加</b-button>
        <b-button class="is-primary addRowButton" icon-left="printer" @click="print">印刷</b-button>
        <b-table
          :data="data.details"
          id="cpapUsedListTable"
          v-bind:key="renderKey"
        >
          <template slot-scope="props">
            <b-table-column label=" ">
              <div class="buttons" style="width:20px;">
                <b-button v-if="props.index!=0"
                class="is-primary has-text-centered" icon-left="arrow-up-bold"
                v-on:click="changeUp(props.index)" style="width:20px;" size="is-small"/>
                <b-button v-if="props.index<data.details.length-1"
                class="is-primary has-text-centered" icon-left="arrow-down-bold"
                v-on:click="changeDown(props.index)" style="width:20px;" size="is-small"/>
              </div>
            </b-table-column>
            <b-table-column label="No." width="40" centered>
              {{props.index + 1}}
            </b-table-column>
            <b-table-column field="patientCode" label="患者ID" width="40" centered sortable>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" class="patientIdInput" v-model="props.row.patientCode" maxlength="20" />
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" class="patientIdInput" v-model="props.row.patientCode" maxlength="20" disabled="disabled"  />
                <input v-if="isExtUser &&  props.row.isAdditional" type="text" class="patientIdInput" v-model="props.row.patientCode" maxlength="20"/>
                <input v-if="isExtUser && !props.row.isAdditional" type="text" class="patientIdInput" v-model="props.row.patientCode" maxlength="20" disabled="disabled" />
              </template>
              <!-- <template>{{props.row.patientCode}}</template> -->
            </b-table-column>
            <b-table-column field="patientName" label="患者名" width="150" centered sortable>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.patientName" maxlength="20" />
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.patientName" maxlength="20" disabled="disabled"  />
                <input v-if="isExtUser &&  props.row.isAdditional" type="text" v-model="props.row.patientName" maxlength="20"/>
                <input v-if="isExtUser && !props.row.isAdditional" type="text" v-model="props.row.patientName" maxlength="20" disabled="disabled" />
              </template>
              <!-- <template v-else>{{props.row.patientName}}</template> -->
            </b-table-column>
            <b-table-column field="itemCode" label="品目コード" width="100" centered sortable>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.itemCode" maxlength="100"/>
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.itemCode" maxlength="100" disabled="disabled"/>
                <input v-if="isExtUser &&  props.row.isAdditional"  type="text" v-model="props.row.itemCode" maxlength="100"/>
                <input v-if="isExtUser && !props.row.isAdditional"  type="text" v-model="props.row.itemCode" maxlength="100" disabled="disabled" />
              </template>
              <!-- <template v-else>{{props.row.itemCode}}</template> -->
            </b-table-column>
            <b-table-column field="itemName" label="品目名" width="180" centered sortable>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.itemName" maxlength="100"/>
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.itemName" maxlength="100" disabled="disabled"/>
                <input v-if="isExtUser &&  props.row.isAdditional"  type="text" v-model="props.row.itemName" maxlength="100"/>
                <input v-if="isExtUser && !props.row.isAdditional"  type="text" v-model="props.row.itemName" maxlength="100" disabled="disabled"/>
              </template>
              <!-- <template v-else>{{props.row.itemName}}</template> -->
            </b-table-column>
            <b-table-column field="serial" label="シリアルNo." width="80" centered sortable>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.serial" maxlength="100"/>
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.serial" maxlength="100" disabled="disabled"/>
                <input v-if="isExtUser &&  props.row.isAdditional" type="text" v-model="props.row.serial" maxlength="100"/>
                <input v-if="isExtUser && !props.row.isAdditional" type="text" v-model="props.row.serial" maxlength="100" disabled="disabled"/>
              </template>
              <!-- <template v-else>{{props.row.serial}}</template> -->
            </b-table-column>
            <b-table-column field="hospitalName" label="医療機関名" width="150" centered v-if="selectDealer" sortable>
              <template v-if="selectDealer">
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.hospitalName" maxlength="20" />
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.hospitalName" maxlength="20" disabled="disabled"  />
                <input v-if="isExtUser &&  props.row.isAdditional" type="text" v-model="props.row.hospitalName" maxlength="20"/>
                <input v-if="isExtUser && !props.row.isAdditional" type="text" v-model="props.row.hospitalName" maxlength="20" disabled="disabled" />
              </template>
              <template v-else-if="selectDealer">{{props.row.hospitalName}}</template>
            </b-table-column>
            <!-- 非表示の要望あり、今後必要になる場合はコメントアウト解除
            <b-table-column field="billingAmount" label="請求額" width="100" centered>
              <template v-if="editable">
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.billingAmount" maxlength="100"/>
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.billingAmount" maxlength="100" disabled="disabled"/>
                <input v-if="isExtUser &&  props.row.isAdditional" type="text" v-model="props.row.billingAmount" maxlength="100"/>
                <input v-if="isExtUser && !props.row.isAdditional" type="text" v-model="props.row.billingAmount" maxlength="100" disabled="disabled"/>
              </template>
              <template v-else>{{props.row.billingAmount}}</template>
            </b-table-column>
            -->
            <b-table-column field="biko" label="備考" width="200" centered>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.biko" maxlength="256"/>
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.biko" maxlength="256" disabled="disabled"/>
                <input v-if="isExtUser &&  props.row.isAdditional" type="text" v-model="props.row.biko" maxlength="256"/>
                <input v-if="isExtUser && !props.row.isAdditional" type="text" v-model="props.row.biko" maxlength="256" disabled="disabled"/>
              </template>
              <!-- <template v-else>{{props.row.biko}}</template> -->
            </b-table-column>
            <b-table-column field="comment" label="得意先記入欄" width="200" centered>
              <template>
                <input v-if="isInnerUser && !props.row.deleteFlag" type="text" v-model="props.row.comment" maxlength="256" disabled="disabled"/>
                <input v-if="isInnerUser &&  props.row.deleteFlag" type="text" v-model="props.row.comment" maxlength="256" disabled="disabled"/>
                <input v-if="isExtUser" type="text" v-model="props.row.comment" maxlength="256"/>
              </template>
              <!-- <template v-else>{{props.row.comment}}</template> -->
            </b-table-column>
            <!-- 営業が顧客に送信する前。不要な行には削除フラグをONにする -->
            <template>
              <b-table-column  v-if="isInnerUser && !data.ApprovalFlag" field="deleteFlag" label="削除" width="20" sortable>
                <b-checkbox class="columnCheckBox" v-model="props.row.deleteFlag"></b-checkbox>
              </b-table-column>
            </template>
            <b-table-column field="isAdditional" label="" width="20" centered>
              <b-button v-if="props.row.isAdditional" class="clearBtn" icon-left="eraser" @click="deleteMember(props.index)"></b-button>
            </b-table-column>
          </template>
        </b-table>
        <div class="button-area">
          <template>
            <b-button v-if="isInnerUser || (isExtUser && !data.ApprovalFlag)" class="is-primary" @click="save">一時保存</b-button>
            <template v-if="isExtUser">
              <!-- ログインユーザーが社外ユーザーの場合-->
              <template v-if="!data.ApprovalFlag">
                <b-button class="is-primary" @click="finishConfirmed">担当者に返送する</b-button>
              </template>
            </template>
            <template v-else-if="isInnerUser">
              <!--１ 対象の医療機関のデータのステータスが、確認中の場合-->
              <template  v-if="!data.ConfirmFlag && !data.ApprovalFlag">
                <b-button class="is-primary" @click="sendCustomer">顧客へ送信する</b-button>
              </template>
              <!--２ 対象の医療機関のデータのステータスが、承認依頼中の場合-->
              <template v-else-if="data.ConfirmFlag && !data.ApprovalFlag"></template>
              <!--３ 対象の医療機関のデータのステータスが、デビクレ中の場合-->
              <template v-else-if="!data.DebitCreditFlag">
                <b-button class="is-primary" @click="finishDebitCredit">デビクレ確定する</b-button>
              </template>
              <!--４ 対象の医療機関のデータのステータスが、デビクレ済みの場合-->
              <template v-else></template>
            </template>
          </template>
        </div>
      </div>
      <!--印刷用-->
      <template>
        <div class="labelTitle lable printTarget" style="visibility:hidden;font-size:20px;">使用明細</div>
        <table class="printTarget" style="visibility:hidden;margin-top:10px;margin-bottom:10px;">
          <tr>
            <th style="width:20%;font-size:18px;">年月：{{convertDate(yearMonth)}}</th>
            <th style="font-size:18px;">医療機関：{{medicalInstitutionName}}</th>
          </tr>
        </table>
        <div class="printTarget" style="visibility:hidden; max-width:251mm;margin-top:5px;">
          <b-table
          :data="data.details">
            <template slot-scope="props">
              <b-table-column label="No." width="40" centered>
                {{props.index + 1}}
              </b-table-column>
              <b-table-column field="patientCode" label="患者ID" width="40" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.patientCode}}</template>
                <template v-else><s>{{props.row.patientCode}}</s></template>
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="150" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.patientName}}</template>
                <template v-else><s>{{props.row.patientName}}</s></template>
              </b-table-column>
              <b-table-column field="itemCode" label="品目コード" width="100" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.itemCode}}</template>
                <template v-else><s>{{props.row.itemCode}}</s></template>
              </b-table-column>
              <b-table-column field="itemName" label="品目名" width="180" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.itemName}}</template>
                <template v-else><s>{{props.row.itemName}}</s></template>
              </b-table-column>
              <b-table-column field="serial" label="シリアルNo." width="80" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.serial}}</template>
                <template v-else><s>{{props.row.serial}}</s></template>
              </b-table-column>
              <b-table-column field="hospitalName" label="医療機関名." width="150" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.hospitalName}}</template>
                <template v-else><s>{{props.row.hospitalName}}</s></template>
              </b-table-column>
              <!-- 非表示の要望あり、今後必要になる場合はコメントアウト解除
              <b-table-column field="billingAmount" label="請求額" width="100" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.billingAmount}}</template>
                <template v-else><s>{{props.row.billingAmount}}</s></template>
              </b-table-column> -->
              <b-table-column field="biko" label="備考" width="80" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.biko}}</template>
                <template v-else><s>{{props.row.biko}}</s></template>
              </b-table-column>
              <b-table-column field="comment" label="得意先記入欄" width="200" centered>
                <template v-if="!props.row.deleteFlag">{{props.row.comment}}</template>
                <template v-else><s>{{props.row.comment}}</s></template>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </template>
    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isInnerUser" :selectRole="[role.role_hospital,role.role_dealer]" :selectStatus="extUserStatus.registed" :cpapUsedList="true" title="組織選択" labelForOrg="組織名" @select="setOrganization"></organizationSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";

export default {
  name: "CpapUsedList",
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    convertDate: function(day){
      return day ? day.replace("-", "年") + "月" : ""
    },
    addRow: function() {
      this.data.details.push({
        displayOrder: 0,
        patientName:"",
        itemName:"",
        serial:"",
        billingAmount:"",
        biko:"",
        comment:"",
        isAdditional:true,
        deleteFlag: false
      })
    },
    deleteMember: function(index){
      this.data.details.splice(index, 1)
    },
    isEditable: function() {
      // 修正可能（締め日（翌月6日）以前）状態判定
      var today = new Date()
      var target = this.yearMonth.replace(/-/g, "")
      var thisMonth = this.yyyy_hyphen_MM(today).replace(/-/g, "")
      if(target == thisMonth){
        // 当月データの場合、修正可能
        return true
      }
      var lastMonth = new Date()
      lastMonth.setMonth(lastMonth.getMonth()-1)
      lastMonth = this.yyyy_hyphen_MM(lastMonth).replace(/-/g, "")
      if(target == lastMonth){
        if(today.getDate() <= 6){
          // 先月データかつ、現在が6日以前の場合、修正可能
          return true
        }
      }
      // 先々月 or 先月かつ現在が6日以降⇒修正不可
      return false
    },
    setOrganization: function(organizationInfo){
      this.selectDealer = organizationInfo.role == role.role_dealer;
      this.medicalInstitutionName = organizationInfo.orgName;
      this.medicalInstitutionCode = organizationInfo.customerCode
    },
    doSearch: function() {
      if (!this.yearMonth){
        this.showErrorMessage("年月が選択されていません。")
        return;
      }
      if (!this.medicalInstitutionName){
        this.showErrorMessage("医療機関が選択されていません。")
        return;
      }
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client) {
          return client.apis.externalCpap.getCpapUsageDetailsListPOST({
            body:{
              yearMonth:_this.yearMonth.replace(/-/g, ""),
              medicalInstitutionCode:_this.medicalInstitutionCode
            }
          })
        },
        function(result) {
          // 検索結果取得
          //_this.editable = _this.isEditable();
          _this.data = result.obj
          _this.origin = JSON.parse(JSON.stringify(result.obj));
          if(!_this.data.ConfirmFlag && !_this.data.ApprovalFlag && !_this.data.DebitCreditFlag){
            // ⇒Philips確認中
            _this.activeStep = 0
          }else if(_this.data.ConfirmFlag && !_this.data.ApprovalFlag && !_this.data.DebitCreditFlag){
            // ⇒得意先確認中
            _this.activeStep = 1
          }else if(_this.data.ConfirmFlag && _this.data.ApprovalFlag && !_this.data.DebitCreditFlag){
            // ⇒Philips内容確認中
            _this.activeStep = 2
          }else if(_this.data.ConfirmFlag && _this.data.ApprovalFlag && _this.data.DebitCreditFlag){
            // ⇒確認完了
            _this.activeStep = 3
          }
          _this.renderKey = !_this.renderKey
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        }
      );
    },
    changeYearMonth: function(){
      this.data = {details:[]}
      this.origin = {details:[]}
    },
    print: function(){
      // 印刷
      window.print();
    },
    // 保存
    save: function(){
      var messsage = "使用明細を保存します。<br/>内容を確認して「OK」ボタンを押してください。"
      var _this = this;
      this.$dialog.confirm({
        title: "保存確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client) {
              var obj = JSON.parse(JSON.stringify(_this.data));
              return client.apis.externalCpap.setCpapUsageDetailsPOST({
                body:obj
              });
            },
            function(result) {
              _this.showSuccess(result);
              _this.doSearch();
            },
            function(result) {
              // エラーメッセージ表示
              _this.showErrorMessage(result);
            },
          )
        }
      });
    },
    // 顧客へ送信する
    sendCustomer: function(){
      var messsage = "使用明細を顧客に送信に返送します。<br/>内容を確認して「OK」ボタンを押してください。"
      var _this = this;
      this.$dialog.confirm({
        title: "送信確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client) {
              var obj = JSON.parse(JSON.stringify(_this.data));
              return client.apis.externalCpap.cpapUsageDetailsSendCustomerPOST({
                body:obj
              })
            },
            function(result) {
              _this.showSuccess(result);
              _this.doSearch()
            },
            function(result) {
              // エラーメッセージ表示
              _this.showErrorMessage(result);
            },
          );
        }
      });
    },
    // 担当者に返送する
    finishConfirmed: function(){
      var messsage = "使用明細を担当者に返送します。<br/>内容を確認して「OK」ボタンを押してください。"
      var _this = this;
      this.$dialog.confirm({
        title: "返送確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client) {
              var obj = JSON.parse(JSON.stringify(_this.data));
              return client.apis.externalCpap.cpapUsageDetailsSendReplayPOST({
                body:obj
              })
            },
            function(result) {
              _this.showSuccess(result);
              _this.doSearch()
            },
            function(result) {
              // エラーメッセージ表示
              _this.showErrorMessage(result);
            },
          );
        }
      });
    },
    // デビクレ処理を完了する
    finishDebitCredit: function(){
      var messsage = "使用明細のデビクレ処理を完了します。<br/>内容を確認して「OK」ボタンを押してください。"
      var _this = this;
      this.$dialog.confirm({
        title: "デビクレ処理完了",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client) {
              var obj = JSON.parse(JSON.stringify(_this.data));
              return client.apis.externalCpap.setCpapUsageDetailsFinishDebitCreditPOST({
                body:obj
              })
            },
            function(result) {
              _this.showSuccess(result);
              _this.doSearch()
            },
            function(result) {
              // エラーメッセージ表示
              _this.showErrorMessage(result);
            },
          );
        }
      });
    },
    changeUp: function(index){
      // 明細をリストの1つ上に移動させる
      this.listMove(this.data.details, index, index-1);
    },
    changeDown: function(index){
      // 明細をリストの1つ下に移動させる
      this.listMove(this.data.details, index, index+1);
    },
    listMove: function(array, beforeIndex, afterIndex){
      if (beforeIndex === afterIndex || beforeIndex > array.length -1 || afterIndex > array.length - 1) {
        return array;
      }
      const value = array[beforeIndex];
      const tail = array.slice(beforeIndex + 1);
      array.splice(beforeIndex);
      Array.prototype.push.apply(array, tail);
      array.splice(afterIndex, 0, value);
      return array;
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isExtUser = (isHospital || isDealer);
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var medicalInstitutionName = isExtUser ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : ""
    var medicalInstitutionCode = isExtUser ? userInfo.medicalInstitutionCode : ""
    var cpapUsageDetailBehalf = userInfo.cpapUsageDetailBehalf
    var yearMonth = this.yyyy_hyphen_MM(new Date())
    var yearMonthMax = this.yyyy_hyphen_MM(new Date())
    var yearMonthMin = new Date()
    yearMonthMin.setMonth(yearMonthMin.getMonth()-2)
    yearMonthMin = this.yyyy_hyphen_MM(yearMonthMin)
    return {
      origin: {details:[]},
      data: {details:[]},
      roleId: roleId,
      userId: userId,
      isDealer: isDealer,
      isExtUser: isExtUser,
      isInnerUser: (isSalesOffice || isHonsha || isAdmin),
      role: role,
      extUserStatus: extUserStatus,
      isPaginated : true,
      organizationModalActive: false,
      medicalInstitutionName,
      medicalInstitutionCode,
      yearMonth,
      yearMonthMax,
      yearMonthMin,
      flg:false,
      editable:false,
      cpapUsageDetailBehalf: cpapUsageDetailBehalf,
      selectDealer:false,
      activeStep:0,
      renderKey:true
    };
  },
  filters: {},
  components: { 
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal
  },
  async mounted() {
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
select {
  width: 200px;
}
.tag {
  width: 100px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}
.rowButton {
    height: 30px;
}
.rowButton.halfSize {
    width: 48%;
}
.addRowButton {
    float: right;
    margin-right: 25px;
    margin-bottom:15px;
}
input.hospitalInput {
  width: 400px !important;
}
input.patientIdInput {
  width: 100px !important;
}
.clearBtn {
  margin-left: 5px;
  height: 27px !important;
  width: 27px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapUsedList.vue